var map = {
	"./albergolosone.jpg": 749,
	"./ameronswissmountain.jpg": 7022,
	"./artdecomontana.jpg": 8654,
	"./arthotel-riposo.jpg": 8870,
	"./ascovilla.jpg": 3975,
	"./atlantis.jpg": 678,
	"./backstage-vernissage.jpg": 7815,
	"./badrutt-s-palace.jpg": 6830,
	"./baur-au-lac.jpg": 2723,
	"./beatus.jpg": 2660,
	"./beaurivage.jpg": 5602,
	"./beaurivagepalace.jpg": 6393,
	"./bergwelt-grindelwald.jpg": 2429,
	"./bodmi.jpg": 5704,
	"./buergenstock.jpg": 6488,
	"./castello_del_sole.jpg": 8519,
	"./chedi.jpg": 1815,
	"./chesa-randolina.jpg": 9812,
	"./de_rougemont.jpg": 3466,
	"./deltapark.jpg": 8255,
	"./doldenhorn.jpg": 249,
	"./dolder-grand.jpg": 761,
	"./eden-roc.jpg": 1627,
	"./ermitage.jpg": 2654,
	"./fairmontlemontreux.jpg": 7437,
	"./fourseasons.jpg": 594,
	"./fruttfamilylodge.jpg": 1108,
	"./giardino.jpg": 2297,
	"./ginabelle.jpg": 8204,
	"./golfpanorama.jpg": 8547,
	"./grandhotelquellenhof.jpg": 7331,
	"./gstaad-palace.jpg": 817,
	"./hof_weissbad.jpg": 8839,
	"./huus-gstaad.jpg": 8466,
	"./kempinski.jpg": 4906,
	"./kulm.jpg": 8348,
	"./la-reserve-geneve.jpg": 5624,
	"./le-grand-bellevue.jpg": 3104,
	"./lenkerhof.jpg": 9125,
	"./lestroisrois.jpg": 6912,
	"./maerchenhotelbraunwald.jpg": 5893,
	"./mandarin-oriental.jpg": 3495,
	"./mirador.jpg": 9294,
	"./nira-alpina.jpg": 5044,
	"./parkhotel-delta.jpg": 1461,
	"./parkhotel-margna.jpg": 7989,
	"./pirmin-zurbriggen.jpg": 5230,
	"./placeholder.jpg": 7489,
	"./priva.jpg": 9621,
	"./radissonblue.jpg": 4990,
	"./rocksresort.jpg": 2446,
	"./romantik-hotel-julen-zermatt.jpg": 8828,
	"./saratz.jpg": 7588,
	"./schweizerhof.jpg": 3789,
	"./schweizerhofbern.jpg": 4368,
	"./spitzhorn.jpg": 2670,
	"./sunstar-arosa.jpg": 4355,
	"./suvretta-house.jpg": 4674,
	"./swiss_holiday_park.jpg": 747,
	"./the-alpina.jpg": 4621,
	"./thehide.jpg": 5469,
	"./tschuggen.jpg": 369,
	"./ultima-gstaad.jpg": 7598,
	"./valbella-resort.jpg": 9243,
	"./valbellainn.jpg": 4801,
	"./valsana.jpg": 2411,
	"./victoriajungfrau.jpg": 6102,
	"./vitznauerhof.jpg": 5158,
	"./widder.jpg": 1246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 529;